// Publish Assignment
export const PUBLISH_ASSIGNMENT_REQUEST = 'PUBLISH_ASSIGNMENT_REQUEST';
export const PUBLISH_ASSIGNMENT_DONE = 'PUBLISH_ASSIGNMENT_DONE';
export const PUBLISH_ASSIGNMENT_FAILED = 'PUBLISH_ASSIGNMENT_FAILED';
export const PUBLISH_ASSIGNMENT_CLEAR_ERRORS = 'PUBLISH_ASSIGNMENT_CLEAR_ERRORS';
export const PUBLISH_ASSIGNMENT_RESET = 'PUBLISH_ASSIGNMENT_RESET';